// app/javascript/controllers/collaborators_controller.js
import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = { users: Array };
  static targets = ['container', 'template', 'select', 'message', 'hiddenMessage'];

  connect() {
    if (this.containerTarget.children.length === 0) {
      this.add();
    }
  }

  add() {
    // Support both <template> and hidden <div> as template
    let clone;
    if (this.templateTarget.tagName === 'TEMPLATE') {
      clone = this.templateTarget.content.cloneNode(true);
    } else {
      // For hidden div, clone its first child
      clone = this.templateTarget.firstElementChild.cloneNode(true);
    }

    const select = clone.querySelector('select');
    this.fillOptions(select);

    if (this.hasMessageTarget) {
      const msg = this.messageTarget.value;
      const hidden = clone.querySelector("[data-collaborators-target='hiddenMessage']");
      if (hidden) hidden.value = msg;
    }

    this.containerTarget.appendChild(clone);
    this.sync();
  }

  remove(event) {
    event.target.closest('div.mb-3').remove();
    this.sync();
  }

  sync() {
    const selectedIds = this.selectTargets.map((s) => s.value).filter(Boolean);

    this.selectTargets.forEach((select) => {
      const currentValue = select.value || '';
      select.innerHTML = '';

      const blank = document.createElement('option');
      blank.value = '';
      blank.textContent = '';
      select.appendChild(blank);

      this.usersValue.forEach(([label, id]) => {
        const idStr = id.toString();
        if (!selectedIds.includes(idStr) || idStr === currentValue) {
          const opt = document.createElement('option');
          opt.value = idStr;
          opt.textContent = label;
          if (idStr === currentValue) opt.selected = true;
          select.appendChild(opt);
        }
      });
    });

    if (this.hasMessageTarget) {
      const msg = this.messageTarget.value;
      this.hiddenMessageTargets.forEach((h) => (h.value = msg));
    }
  }

  fillOptions(select) {
    const blank = document.createElement('option');
    blank.value = '';
    blank.textContent = '';
    select.appendChild(blank);

    this.usersValue.forEach(([label, id]) => {
      const opt = document.createElement('option');
      opt.value = id;
      opt.textContent = label;
      select.appendChild(opt);
    });
  }
}
